import React, { useState, useEffect } from 'react';
import './Content.css';
import ParticleHeaderBg from '../ParticlesBg/ParticlesHeader/ParticleHeaderBg';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-scroll';

import profileImage from '../../img/home.png';

// Social media data
const socialLinks = [
  { id: 'linkedin', url: 'https://www.linkedin.com/in/arun-singh-5a0237303', icon: 'fab fa-linkedin', delay: '1200', color: '#0077B5' },
  { id: 'github', url: 'https://github.com/Arunchy07', icon: 'fab fa-github', delay: '1400', color: '#333' },
  { id: 'instagram', url: 'https://www.instagram.com/arun_ch0udhary_/', icon: 'fab fa-instagram', delay: '1600', color: '#E1306C' },
  { id: 'whatsapp', url: 'https://api.whatsapp.com/send?phone=918082065540', icon: 'fab fa-whatsapp', delay: '1800', color: '#25D366' },
];

const Content = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="contenido">
      <ParticleHeaderBg />
      <section className="inicio" id="inicio">
        <div className="container">
          <div className="profile-section">
            <div className="image-container" data-aos="fade-right" data-aos-delay="400">
              <div className="profile-image-wrapper">
                <img src={profileImage} alt="Arun Singh" className="profile-img" />
                <div className="image-overlay"></div>
                <div className="floating-elements">
                  <div className="floating-element element-1">💀</div>
                  <div className="floating-element element-2">⚛️</div>
                  <div className="floating-element element-3">💻</div>
                </div>
              </div>
            </div>
            
            <div className="content-section" data-aos="fade-left" data-aos-delay="600">
              <div className="greeting-badge">
                <FormattedMessage id='greeting' defaultMessage='Hello' />
              </div>
              
              <h1 className="main-title">
                <FormattedMessage id='name' defaultMessage='I am Arun Singh' />
              </h1>
              
              <div className="typewriter-container">
                <p className="role-text">
                  <FormattedMessage id='rol' defaultMessage='Python Full-stack & App developer' />
                </p>
              </div>
              
              <p className="description">
                Passionate about creating innovative digital solutions that bridge technology and user needs. 
                I specialize in building responsive, performant web and mobile applications.
              </p>
              
              <div className="cta-buttons">
                <Link 
                  to="proyectos" 
                  spy={true} 
                  smooth={true} 
                  offset={-70} 
                  duration={500} 
                  className="btn primary-btn"
                >
                  View My Work
                </Link>
                <Link 
                  to="contactos" 
                  spy={true} 
                  smooth={true} 
                  offset={-70} 
                  duration={500} 
                  className="btn secondary-btn"
                >
                  Get In Touch
                </Link>
              </div>
              
              <div className="social-links-modern">
                {socialLinks.map(link => (
                  <a
                    key={link.id}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    style={{ '--hover-color': link.color }}
                    aria-label={link.id}
                  >
                    <i className={link.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        <Link to="sobre-mi" spy={true} smooth={true} offset={-70} duration={500} className="scroll-link">
          <div className="scroll-down">
            <div className="scroll-arrow"></div>
          </div>
        </Link>
      </section>
    </div>
  );
};

export default Content;